export const pressureSystemInStairwellsInspectionCases = [
  {
    section: '1',
    title: 'בדיקת תכנון/התקנה',
    isTitle: true,
    subCases: [
      {
        section: '1.1',
        title: 'התקבלו תוכניות בטיחות מאושרות ע"י רשות כבאות והצלה',
        isTitle: false
      },
      {
        section: '1.2',
        title:
          'התקבלו תוכניות מיזוג אוויר מפורטות כולל חתכים ומידות בקנה מידה, במידת הצורך',
        isTitle: false
      },
      {
        section: '1.3',
        title: 'מסמכים ואישורים על בסיסם בוצע הבדיקה',
        isTitle: true
      },
      {
        section: '1.3.1',
        title:
          'הצהרת ואישור מתכן מיזוג אוויר לציוד וחומרים בפרויקט ע"פ ת"י 1001',
        isTitle: false
      },
      {
        section: '1.3.2',
        title:
          'הצהרת ואישור קבלן מיזוג אוויר לציוד וחומרים בפרויקט ע"פ ת"י 1001',
        isTitle: false
      },
      {
        section: '1.3.3',
        title: 'אישור בודק חשמל ללוחות המיזוג, המפוחים בפרויקט',
        isTitle: false
      },
      {
        section: '1.3.4',
        title: 'תעודות בדיקה למפוחי פינוי עשן ע"פ ת"י 1001 חלק 7',
        isTitle: false
      },
      {
        section: '1.3.5',
        title: 'משטר הפעלות מערכות בטיחות אש ע"פ הוראות מכ"ר 536',
        isTitle: false
      },
      {
        section: '1.3.6',
        title: 'תעודת בדיקה למערכת גילוי האש ע"פ ת"י 1220 חלק 3',
        isTitle: false
      }
    ]
  },
  {
    section: '3',
    title: 'הגדרות',
    isTitle: true,
    subCases: [
      {
        section: '3.3',
        title: 'הגדרות כלליות',
        isTitle: true
      },
      {
        section: '3.3.8',
        title:
          'תחנת בקרת עשן פנל כבאים ( FSCS )\nעל התחנה להיות ממוקמת במיקום המיועד לכך בבניין ע"פ תוכנית הבטיחות,\nבתחנה נדרש להיות תרשים גרפי מספק של כל הציוד המערכת ואמצעי אכיפה ידניים על פעולת המערכת.',
        isTitle: false
      },
      {
        section: '3.3.8.1',
        title:
          'אפסקת זרם אוויר משתנה\nבמערכת אספקת זרם אוויר מווסתת ע"י ווסת תדר, הווסת נשלט ע"י חיישן לחץ הממוקם בין חדר המדרגות לבין האטמוספרה. הווסת נשלט ע"י חיישן לחץ אחד או יותר, באמצעות הווסת נשמר הפרש לחצים עודף בין חדר המדרגות לבניין.',
        isTitle: false
      }
    ]
  },
  {
    section: '4',
    title: 'יסודות התכנון',
    isTitle: true,
    subCases: [
      {
        section: '4.4',
        title: 'קריטריוני תכנון',
        isTitle: true
      },
      {
        section: '4.4.2',
        title: 'בסיס תכנון',
        isTitle: true
      },
      {
        section: '4.4.2.1.1',
        title:
          'הפרשי הלחצים בטבלה A4.4.2.1.1 ישמשו לתכנים המבוססים על שמירה על הפרשי לחצים מינימליים בין חללים מוגדרים.',
        isTitle: false
      },
      {
        section: '4.4.2.1.5',
        title:
          "תכנון המערכת עבור על-לחץ בחדרי מדרגות יהיה כמפורט להלן:\n-  מספר הדלתות הפתוחות עבור 10 הקומות הראשונות: דלת אחת באחת מהקומות נוסף על דלת יציאה מחדר מדרגות המובילה ישירות אל חוץ הבניין. אם דלת זו אינה מובילה ישירות אל החוץ, תוסף גם דלת המובילה ישירות החוצה.\n-  עבור כל 10 קומות נוספות, תוסף עוד דלת אחת.\n-  דלת בבניין תיפתח בזווית של 45 מעלות ודלת יציאה תיפתח פתיחה מלאה.\n-  המהירות המתוכננת של האוויר דרך דלת פתוחה, שאינה הדלת הפתוחה המובילה אל חוץ הבניין, תהיה 1 מ' לשנייה.",
        isTitle: false
      },
      {
        section: '4.4.2.2',
        title:
          'הפרשי לחצים בשני עברי דלתות: \nהפרשי הלחצים בשני עברי הדלתות לא יגרמו לכוח המקסימלי המותר להתחלת פתיחת הדלת לעלות על המותר',
        isTitle: false
      },
      {
        section: '4.6',
        title: 'מערכות דיחוס בחדרי מדרגות',
        isTitle: true
      },
      {
        section: '4.6.1',
        title:
          'כללי\nכאשר מסופקות מערכות דיחוס בחדרי מדרגות, הפרש הלחצים בין אזור העשן לבין חדר המדרגות, ללא דלתות פתוחות ועם מספר מתוכנן של דלתות פתוחות, יהיה כדלקמן:\n1 - לא פחות מהפרש הלחצים המינימלי המצוין בסעיף 4.4.2 (עם דלתות פתוחות)\n2 - לא יותר מהפרש הלחצים המקסימלי המצוין בסעיף 4.4.2.2 (ללא דלתות פתוחות)',
        isTitle: false
      },
      {
        section: '4.6.2',
        title:
          'מיקום מקור אספקת האוויר: \nפתח כניסת אספקת האוויר צריך להיות מופרד מכל פתחי הפליטה של הבניין, יציאות פירי עשן, פתחי עשן וחום בגג, פירי מעליות, וכן מפתחי אחרים בבניין העלולים לפלוט עשן כשפורצת שריפה.',
        isTitle: false
      },
      {
        section: '4.6.3.1',
        title:
          'מאווררי מדחף: \nמאווררי מדחף המותקנים על הגג או על הקיר החיצוני מותרים לשימוש במערכות כניסת אוויר יחידה, בתנאי שיסופקו למאוורר מגני רוח.',
        isTitle: false
      },
      {
        section: '4.6.3.2',
        title:
          'סוגי מאווררים אחרים\nבמערכות כניסת אוויר יחידה, או כניסות אוויר מרובות, מותר השימוש במאווררים צנטריפוגליים או במאווררים ציריים.',
        isTitle: false
      },
      {
        section: '4.6.4.1',
        title: 'מערכות כניסת אוויר יחידה',
        isTitle: true
      },
      {
        section: '4.6.4.1.1',
        title:
          'נקודת כניסת האוויר במערכת כניסת אוויר יחידה תהיה רשאית להיות ממוקמת בכל מקום בתוך חדר המדרגות.',
        isTitle: false
      },
      {
        section: '4.6.4.1.2',
        title:
          "ניתוח התכנון יתבצע עבור כל מערכות הכניסה היחידה במפלס הקרקע ועבור כל מערכות כניסת האוויר היחידה בחדרי המדרגות שגובהם עולה על 30.5 מ'.",
        isTitle: false
      },
      {
        section: '4.6.4.2',
        title:
          'מערכת כניסות אוויר מרובות: \nעבור מערכת עם נקודות כניסה במרחק של יותר משלוש קומות זו מזו, יבוצע ניתוח תכנון כדי להבטיח כי איבוד של אוויר דחוס דרך דלתות פתוחות אינו מוביל לדיחוס מתחת ללחץ המינימלי המתוכנן בחדר המדרגות.',
        isTitle: false
      }
    ]
  },
  {
    section: '6',
    title: 'ציוד בנייה ובקרות',
    isTitle: true,
    subCases: [
      {
        section: '6.4',
        title: 'מערכות בקרת עשן',
        isTitle: true
      },
      {
        section: '6.4.1',
        title: 'לוח הבקרה ישא אישור UL864 ע"פ קטגוריה UUKL',
        isTitle: false
      },
      {
        section: '6.4.4.1.1',
        title:
          'מערכות בקרת עשן יופעלו אוטומטית בתגובה לאותות המתקבלים מהתקן גילוי אש ספציפי או משילוב של התקני גילוי אש, ע"פ משטר ההפעלות למערכות בטיחות אש הוראות מכ"ר 536.',
        isTitle: false
      },
      {
        section: '6.4.4.2',
        title:
          'הפעלה ידנית\nיש להתקין בתחנת בקרת העשן (פנל כבאים) מתג אכיפה להפעלה מחודשת של מאווררי דיחוס חדר מדרגות אחרי הפסקתם ע"י גלאי העשן.',
        isTitle: false
      },
      {
        section: '6.4.4.2.6',
        title:
          'מתגים ידניים המופעלים במפתח והמסומנים בבירור כדי לזהות את תפקידם יורשו להפעיל את מערכת בקרת העשן באופן ידני.',
        isTitle: false
      },
      {
        section: '6.4.5.1',
        title:
          'מערכות בקרת העשן חייבות להיות ניתנות להפעלה מתחנת בקרת העשן של מכבי האש באמצעות מתגים המסומנים בבירור כדי לזהות את מיקומם ואת תפקידם.',
        isTitle: false
      },
      {
        section: '6.4.5.4',
        title: 'תחנת בקרת עשן של מכבי האש (FSCS)',
        isTitle: true
      },
      {
        section: '6.4.5.4.1',
        title:
          'כל מערכות בקרת העשן חייבות להיות מצוידות בתחנת בקרת עשן של מכבי האש.',
        isTitle: false
      },
      {
        section: '6.4.5.4.2',
        title: 'יש להתקין תחנה זו במיקום הקביל על ידי הרשות המוסמכת.',
        isTitle: false
      },
      {
        section: '6.4.5.4.3',
        title:
          'התחנה צריכה לספק חיווי של המצב, חיווי של תנאי תקלות, ולאפשר הפעלה ידנית של כל רכיבי מערכת בקרת העשן.',
        isTitle: false
      },
      {
        section: '6.4.5.4.4',
        title:
          'חיווי המצב ואמצעי הבקרה חייבים להיות מסודרים ומתויגים כדי להבהיר את המטרות המיועדות של המערכת.',
        isTitle: false
      },
      {
        section: '6.4.5.4.5',
        title:
          'יש להבטיח אמצעי בקרת מפעיל, חיווי של המצב וחיווי של תקלות לכל אזור בקרת עשן, לכל פריט ציוד שאפשר להפעילו לבקרת עשן, או שילוב של גישות אלה.',
        isTitle: false
      },
      {
        section: '6.4.5.4.12',
        title:
          'כאשר מותקנות גם בקרות ידניות לבקרה על מערכות בקרת עשן במקומות אחרים בבניין, מצב הבקרה שנבחר מתחנת בקרת העשן של מכבי האש יגבר על כולן.',
        isTitle: false
      },
      {
        section: '6.4.6',
        title:
          'אמצעי בקרה למערכות דיחוס בחדרי מדרגות: \nכאשר יש להתקין מערכות דיחוס בחדרי מדרגות, יש להפעילן כמפורט להלן בסעיף זה:',
        isTitle: true
      },
      {
        section: '6.4.6.1.1',
        title:
          'הפעלה של מערכת אזעקת האש באזור כלשהו בבניין צריכה להפעיל את מאווררי ויסות הלחץ בחדר המדרגות, מלבד כאשר ניתוח הנדסי קובע שאינה נדרשת פעולה של כל מאווררי ויסות הלחץ בחדר המדרגות כדי להשיג את מטרת התכנון, רק מאווררי ויסות הלחץ בחדר המדרגות שזוהו במהלך הניתוח יידרשו לפעול.',
        isTitle: false
      },
      {
        section: '6.4.6.2.1',
        title: 'יש להתקין גלאי עשן במערכת אספקת האוויר לחדר המדרגות הדחוס.',
        isTitle: false
      },
      {
        section: '6.4.6.2.2',
        title: 'בעת גילוי עשן במערכת אספקת האוויר, מאווררי האספקה יעצרו.',
        isTitle: false
      },
      {
        section: '6.4.6.4.1',
        title:
          'יש להתקין בקרת הפעלה והפסקה ידנית של מערכות ויסות הלחץ בחדרי המדרגות בתחנת בקרת העשן של מכבי האש.',
        isTitle: false
      },
      {
        section: '6.4.6.4.2',
        title:
          'מותר להתקין בתחנת בקרת העשן של מכבי האש מתג עקיפה להפעלה מחודשת של מאווררי ויסות הלחץ בחדר המדרגות אחרי הפסקתם על ידי גלאי העשן.',
        isTitle: false
      },
      {
        section: '6.6',
        title: 'חומרים.',
        isTitle: true
      },
      {
        section: '6.6.1',
        title:
          'החומרים המשמשים במערכות בקרת עשן חייבים לעמוד בדרישות ת"י 1001 חלק 1 ובדרישות של מסמכי NFPA ישימים אחרים.',
        isTitle: false
      },
      {
        section: '6.6.2',
        title:
          'יש לבחור את חומרי התעלות ולתכנן אותן להעברת עשן, לעמידה בלחץ נוסף (חיובי ושלילי) המופעל על ידי מאווררי האספקה והפליטה כאשר המערכת פועלת במצב בקרת עשן, ולשמירה על שלמותן המבנית של התעלות למשך הזמן שבו המערכת מתוכננת לפעול.',
        isTitle: false
      },
      {
        section: '6.6.3',
        title:
          'פרטי הציוד הכוללים, בין היתר, מאווררים, תעלות ומדפי ויסות, חייבים להיות מתאימים לשימושם המיועד, לרבות עמידה בטמפרטורות החזויות שלהן הם עשויים להיות חשופים.',
        isTitle: false
      },
      {
        section: '6.7',
        title: 'התקנת שירותי חשמל',
        isTitle: true
      },
      {
        section: '6.7.1',
        title:
          'כל התקנות החשמל חייבות לעמוד בדרישות חוק החשמל, התשי"ד-1954, על תקנותיו ועדכוניהם.',
        isTitle: false
      },
      {
        section: '6.7.2',
        title:
          "יש לתכנן את מערכת בקרת העשן כך שנפילת זרם החשמל הרגיל למשך עד 15 דק' תגרום לרכיבים לבצע את תפקידם באופן אוטומטי עם חזרת זרם החשמל.",
        isTitle: false
      },
      {
        section: '6.7.3',
        title:
          'מסופק זרם חשמל בכוננות (standby) לפי תקן NFPA 110,  יש להפריד את מקור זרם החשמל בכוננות ואת מתגי ההעברה הקשורים אליו מהשנאים וממערכות המיתוג של אספקת הכוח העיקרית ולסגור אותם בחדר בעל מחסום אש בעל דרגת עמידות באש של שעה אחת המותקן לפי חוק התכנון והבנייה, התשכ"ה-1965, על תקנותיו ועדכוניהם.',
        isTitle: false
      }
    ]
  },
  {
    section: '8',
    title: 'בדיקה',
    isTitle: true,
    subCases: [
      {
        section: '8.2',
        title: 'ביקורות בניין מקדימות',
        isTitle: true
      },
      {
        section: '8.2.1',
        title: 'לפני הבדיקה, על הגוף האחראי לביצועה לוודא שלמות מבנה הבניין.',
        isTitle: false
      },
      {
        section: '8.2.2',
        title:
          'יבוקרו הרכיבים האדריכליים הבאים, ככל שהדבר ישים:\n(1) מחסומי עשן, כולל המחברים שלהם \n(2) שלמות הפיר\n(3) אמצעי עצירת האש \n(4) דלתות/מנגנוני סגירה \n(5) זיגוג, כולל כזה התוחם חלל בעל נפח גדול \n(6) מחיצות ותקרות',
        isTitle: false
      },
      {
        section: '8.3.1',
        title:
          'המערכת מוכנה לבדיקת הקבלה: נמצאת לאחר התקנה סופית של כלל חלקי המערכת ופועלת באופן תקין.',
        isTitle: false
      },
      {
        section: '8.4',
        title: 'בדיקות קבלה',
        isTitle: true
      },
      {
        section: '8.4.1',
        title:
          'כללי:\nבדיקות הקבלה נועדו להוכיח כי התקנת המערכת המשולבת הסופית עומדת בתכנון הספציפי ופועלת באופן תקין.',
        isTitle: false
      },
      {
        section: '8.4.2',
        title:
          'פרמטרי בדיקה: \nבמקומות המתאימים בתכנון, כל הפרמטרים יימדדו במהלך בדיקות הקבלה.',
        isTitle: false
      },
      {
        section: '8.4.3',
        title:
          'מקומות המדידה: \nהמקומות למדידת הפרמטרים שזוהו בסעיף 8.4.2 יהיו בהתאם לשיטות מוכרות ארציות.',
        isTitle: false
      },
      {
        section: '8.4.4.1',
        title:
          'לפני תחילת בדיקת הקבלה יש להציב את כל פרטי ציוד הבניין במצב הפעלה רגיל, כולל הציוד שאינו משמש ביישום בקרת העשן.',
        isTitle: false
      },
      {
        section: '8.4.4.2',
        title:
          'אם אספקת החשמל בכוננות מותקנת להפעלת מערכת בקרת העשן, יש לבצע את בדיקת הקבלה בהסתמך הן על אספקת החשמל הרגילה והן על אספקת החשמל בכוננות.',
        isTitle: false
      },
      {
        section: '8.4.4.4',
        title:
          'הרצף השלם של בקרת העשן יוכח עבור מצבי הבקרה הבאים:\n(1) מצב רגיל\n(2) מצב בקרת עשן אוטומטית בעקבות אזעקה ראשונה \n(3) מעבר לאספקת חשמל בהמתנה אם קיימת.\n(4) חזרה למצב רגיל',
        isTitle: false
      },
      {
        section: '8.4.4.5',
        title:
          'הכוח הדרוש כדי לפתוח כל דלת מילוט יימדד באמצעות מאזני קפיץ ויירשם.',
        isTitle: false
      },
      {
        section: '8.4.4.6',
        title:
          'כוחות פתיחת הדלת לא יעלו על אלה שנקבעו בקוד הבנייה (133.4 ניוטון)',
        isTitle: false
      },
      {
        section: '8.4.6.1.1',
        title:
          'כאשר מערכת הבלימה מופעלת, הפרש לחצים על פני כל מחסום עשן יימדד ויתועד עם כל הדלתות הפנימיות סגורות.',
        isTitle: false
      },
      {
        section: '8.4.6.1.2',
        title:
          'אם דלת חיצונית תהיה פתוחה באופן רגיל במהלך פינוי, היא תהיה פתוחה במהלך הבדיקה.',
        isTitle: false
      },
      {
        section: '8.4.6.1.3',
        title:
          'מערכת החימום, האוורור ומיזוג האוויר תהיה כבויה אלא אם המצב הרגיל הוא להשאיר אותה פועלת בעת פעולות בקרת העשן.',
        isTitle: false
      },
      {
        section: '8.4.6.1.4',
        title:
          'כאשר מערכת הבלימה מופעלת ומספר דלתות המילוט המשמשות בתכנון המערכת פתוח, יימדד ויתועד הפרש לחצים על פני המחסום.',
        isTitle: false
      },
      {
        section: '8.4.6.1.5',
        title:
          'אף הפרש לחצים לא יהיה נמוך מהפרשי הלחצים המינימליים המתוכננים המופיעים בטבלה 4.4.2.1.1 או מהלחצים המצוינים במסמכי התכנון.',
        isTitle: false
      },
      {
        section: '8.4.6.2.1',
        title:
          'כאשר מערכת הבלימה מופעלת ומספר דלתות המילוט המשמשות בתכנון המערכת פתוח, יימדד ויתועד הכוח הנדרש כדי לפתוח כל דלת מילוט.',
        isTitle: false
      },
      {
        section: '8.4.6.2.2',
        title:
          'כל הדלתות האחרות תהיינה סגורות כאשר ייערכו המדידות שצוינו בסעיף 8.4.6.2.1.',
        isTitle: false
      },
      {
        section: '8.4.6.3.1',
        title:
          'הדרישות בסעיף 8.4.6.3 ישימות למקרים שבהם ויסות הלחץ בחדרי המדרגות הוא מערכת בקרת העשן היחידה בבניין.',
        isTitle: false
      },
      {
        section: '8.4.6.3.2',
        title:
          'כאשר ויסות הלחץ בחדרי המדרגות משמש בשילוב עם בקרת עשן לפי אזורים, יחולו דרישות סעיף 8.4.6.7.1.',
        isTitle: false
      },
      {
        section: '8.4.6.3.3',
        title:
          'יש להתייחס למבואות כניסה לחדרי מדרגות דחוסים כאזור במערכת בקרת עשן לפי אזורים.',
        isTitle: false
      },
      {
        section: '8.4.6.6.1',
        title: 'יש להתייחס לאזור מילוט מעשן כאזור במערכת בקרת עשן לפי אזורים.',
        isTitle: false
      },
      {
        section: '8.4.6.7.1.1',
        title:
          'יש להתייחס למערכת ויסות הלחץ בחדרי מדרגות כאזור אחד במערכת בקרת עשן לפי אזורים.',
        isTitle: false
      },
      {
        section: '8.7',
        title: 'שינויים.',
        isTitle: true
      },
      {
        section: '8.7.1',
        title:
          'כאשר המערכת עוברת שינוי או שדרוג, יש לבצע את כל בדיקות ההפעלה והקבלה על חלק המערכת ששונה.',
        isTitle: false
      },
      {
        section: '8.7.2',
        title:
          'אם מערכת בקרת העשן או גבולות האזור שונו מאז הבדיקה האחרונה, יש לבצע את בדיקות הקבלה על החלק ששונה.',
        isTitle: false
      },
      {
        section: '8.7.3',
        title: 'יש לעדכן את התיעוד כדי לשקף בו את השינויים או השדרוגים שבוצעו.',
        isTitle: false
      }
    ]
  }
];
